import React from 'react';

const Button = ({ text = 'text', action }) => {
  return (
    <div className="mb-8" onClick={action}>
      <div className="px-8 py-3 cursor-pointer mt-8 border-suzGreen border text-suzGreen bg-transparent hover:bg-suzGreen hover:text-black transition-all duration-150">
        {text}
      </div>
    </div>
  );
};

export default Button;
